
<bn-loading-overlay></bn-loading-overlay>

<div class="container">
  <form [formGroup]="formEmpresa" class="form">

    <div class="row">
      <div class="col">
        <h3>
          {{ modoDetalhe ? "Detalhe da empresa irregular" : "Cadastro de empresa irregular"}}
          <small *ngIf="model?.id" class="text-muted">(#ID: {{ model.id }})</small>
        </h3>
      </div>
      <div class="col-auto">
        <!-- <button type="button" class="btn btn-primary" (click)="voltarParaLista()">{{ modoEdicao ? "Cancelar" : "Voltar"}}</button> -->

        <button type="button" class="btn btn-primary" (click)="voltarParaLista()">Voltar</button>

        <button type="button" class="btn btn-primary"
          (click)="salvar()">Salvar
        </button>

      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label"><b>CNPJ:</b></label>
        <input  class="form-control" name="cnpj" ngDefaultControl formControlName="cnpj" [readonly]="modoDetalhe"/>
        <!-- <input  bnMask="CNPJRAIZ" class="form-control" name="cnpj" ngDefaultControl formControlName="cnpj" [readonly]="modoDetalhe"/> -->
      </div>

      <div class="bn-form-group col-md-6">
        <label class="form-label"><b>Tipo da irregularidade:</b></label>
        <div *ngIf="modoDetalhe; else modoCadastro">
          <select type="text" class="form-select" formControlName="tipo" readonly>
            <option [ngValue]="tipo.codigo" *ngFor="let tipo of tipos">
                {{tipo.nome}}
            </option>
          </select>
        </div>
        <ng-template #modoCadastro>
          <select type="text" class="form-select" formControlName="tipo">
            <option [ngValue]="tipo.codigo" *ngFor="let tipo of tipos">
                {{tipo.nome}}
            </option>
          </select>
        </ng-template>
      </div>

      <div class="bn-form-group col-md-6">
        <label class="form-label"><b>Data início:</b></label>
        <bn-datepicker name="dataInicio" ngDefaultControl formControlName="dataInicio" [disabled]="modoDetalhe">
        </bn-datepicker>
      </div>

      <div class="bn-form-group col-md-6">
        <label class="form-label"><b>Data fim:</b></label>
        <bn-datepicker name="dataFim" ngDefaultControl formControlName="dataFim"></bn-datepicker>
      </div>
    </div>
  </form>
</div>
